import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "export-profiles" };
const _hoisted_2 = { class: "data-table__value-text" };
import { onMounted, onUnmounted, ref } from 'vue';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import exportProfileRepository from "../services/ShopExportProfileRepository";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import DeleteExportProfile from "../commands/DeleteShopExportProfile";
import BadgeComponent from "@astina/paloma-common-ui/src/components/BadgeComponent.vue";
import DuplicateExportProfile from "../commands/DuplicateShopExportProfile";
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportProfilesView',
    setup(__props) {
        const router = useRouter();
        const source = exportProfileRepository.getGridItemsSource();
        const grid = ref(null);
        const searchRequest = ref({
            query: null,
            filters: [],
        });
        events.$on([
            'command.save_shop_export_profile.success',
            'command.delete_shop_export_profile.success',
            'command.duplicate_shop_export_profile.success',
        ], onShopExportCommandSuccess);
        events.$on('command.duplicate_shop_export_profile.success', onDuplicateShopExportProfileSuccess);
        onUnmounted(() => {
            events.$off([
                'command.save_shop_export_profile.success',
                'command.delete_shop_export_profile.success',
                'command.duplicate_shop_export_profile.success',
            ], onShopExportCommandSuccess);
            events.$off('command.duplicate_shop_import_profile.success', onDuplicateShopExportProfileSuccess);
        });
        function onShopExportCommandSuccess() {
            events.$emit('export-profiles.refresh');
        }
        function onDuplicateShopExportProfileSuccess(profile) {
            router.push({ name: 'integration_export_edit', params: { id: profile.id } });
        }
        onMounted(() => {
            exportProfileRepository.getGridConfig()
                .then(g => {
                grid.value = g;
            });
        });
        function activateItem(item) {
            router.push({ name: 'integration_export_details', params: { id: item.id } }).catch(() => {
            });
        }
        function createProfileDuplicateCommand(profileId) {
            return new DuplicateExportProfile(profileId);
        }
        function createProfileDeleteCommand(profileId) {
            return new DeleteExportProfile(profileId);
        }
        function closeView() {
            router.push({ name: 'integration_export' });
        }
        function prevItem() {
            events.$emit('export-profiles.nav-prev');
        }
        function nextItem() {
            events.$emit('export-profiles.nav-next');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_badge = _resolveComponent("badge");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value
                }, null, 8, ["loading"]),
                _cache[9] || (_cache[9] = _createTextVNode()),
                (grid.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(DataTable, {
                            name: "export-profiles",
                            "search-request": searchRequest.value,
                            grid: grid.value,
                            source: _unref(source),
                            onActivateItem: activateItem
                        }, {
                            actions: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_export_create' },
                                    class: "button button--primary"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "plus" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('export_profile.create')), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            "list-item": _withCtx((props) => [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_export_details', params: { id: props.item.id } },
                                    class: "data-table__value"
                                }, {
                                    default: _withCtx(() => [
                                        _withDirectives(_createElementVNode("span", { class: "data-table__value-topic" }, _toDisplayString(props.item.topic), 513), [
                                            [_vShow, props.item.topic]
                                        ]),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(props.item.title), 1),
                                        _cache[1] || (_cache[1] = _createTextVNode()),
                                        _createVNode(_component_badge, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.item.attributes['format']), 1)
                                            ]),
                                            _: 2
                                        }, 1024),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        _createVNode(_component_badge, null, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(props.item.attributes['transport']), 1)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1032, ["to"])
                            ]),
                            "item-actions": _withCtx((props) => [
                                (!props.item.attributes['managedByIntegration'])
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(_component_router_link, {
                                            to: { name: 'integration_export_edit', params: { id: props.item.id } },
                                            class: "button button--link",
                                            href: ""
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(Icon, { name: "pencil" })
                                            ]),
                                            _: 1
                                        }, 8, ["to"]),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        _createVNode(CommandButton, {
                                            command: createProfileDuplicateCommand(props.item.id),
                                            classes: ['button', 'button--link'],
                                            label: ""
                                        }, null, 8, ["command"]),
                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                        _createVNode(CommandButton, {
                                            command: createProfileDeleteCommand(props.item.id),
                                            classes: ['button', 'button--link'],
                                            label: ""
                                        }, null, 8, ["command"])
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ]),
                            "cell-status": _withCtx((props) => [
                                _createVNode(BadgeComponent, {
                                    variant: props.item.attributes['status']
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(props.item.attributes['status']), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["variant"])
                            ]),
                            _: 1
                        }, 8, ["search-request", "grid", "source"]),
                        _cache[8] || (_cache[8] = _createTextVNode()),
                        _createVNode(_component_router_view, {
                            onClose: closeView,
                            onNext: nextItem,
                            onPrev: prevItem
                        })
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
